import remarkGfm from "remark-gfm";
import remarkParse from "remark-parse";
import remarkStringify from "remark-stringify";
import stripMarkdown from "strip-markdown";
import { unified } from "unified";

const processor = unified().use(remarkParse).use(remarkGfm).use(stripMarkdown).use(remarkStringify);

/**
 * Flatten a markdown string to plain text for dense previews (cards, list rows).
 *
 * Parses GFM (matching how detail pages render) and strips all formatting —
 * headings, emphasis, strikethrough, code, lists, link urls (label kept), image
 * markup (alt text kept). Tables are dropped entirely. Whitespace is collapsed
 * so the result fits a single clamped line without leaking literal `#`, `*`,
 * `~`, or `|` characters. Render real markdown on detail pages, not here.
 */
export const stripMarkdownToText = (markdown: string): string =>
  String(processor.processSync(markdown)).replace(/\s+/g, " ").trim();
